require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/script-loader/addScript.js")(require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/raw-loader/index.js!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/easy-pie-chart/dist/easypiechart.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/easy-pie-chart/dist/easypiechart.js
// module id = 743
// module chunks = 15